<script setup lang="ts">
interface Props {
  class?: string
}

const props = withDefaults(defineProps<Props>(), {
  class: ''
})
</script>

<template>
  <div :class="['w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8', props.class]">
    <slot />
  </div>
</template>
